import axios, { type AxiosResponse } from 'axios';
import { type TypeCommon } from '../types/common';
import { LOCAL_STORAGE_KEY } from '../constants/common.constants';

const axiosInstance = axios.create({
  baseURL: import.meta.env['VITE_APP_BASE_URL'] || '',
  withCredentials: false,
});

axiosInstance.interceptors.request.use(
  async (config: TypeCommon) => {
    const token = localStorage.getItem(LOCAL_STORAGE_KEY.NON_USER_TOKEN);

    const extraHeaders = token
      ? {
          Authorization: `Bearer ${token}`,
          is_web: true,
        }
      : {};

    config.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...config.headers,
      ...extraHeaders,
    };
    config.counter = config.counter || 0;
    return config;
  },
  (error: Error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    return Promise.reject(error);
  }
);

export const get = (
  url: string,
  params?: TypeCommon,
  type?: TypeCommon,
  headers?: TypeCommon,
  baseURL?: string
): Promise<AxiosResponse> => {
  const config: TypeCommon = {
    headers,
    params,
  };

  if (type) {
    config.responseType = type;
  }

  if (baseURL) {
    config.baseURL = baseURL;
  }

  return axiosInstance.get(url, config);
};
export const post = (
  url: string,
  body?: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon,
  baseURL?: string
): Promise<AxiosResponse> => {
  const config: TypeCommon = {
    headers,
    params,
  };

  if (baseURL) {
    config.baseURL = baseURL;
  }

  return axiosInstance.post(url, body, config);
};

export const put = (
  url: string,
  body?: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon
): Promise<AxiosResponse> => {
  return axiosInstance.put(url, body, {
    headers,
    params,
  });
};
export const patch = (
  url: string,
  body?: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon
): Promise<AxiosResponse> => {
  return axiosInstance.patch(url, body, {
    headers,
    params,
  });
};
export const deleteMethod = (
  url: string,
  data?: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon
): Promise<AxiosResponse> => {
  return axiosInstance.delete(url, {
    data,
    headers,
    params,
  });
};
